import { createContextLocalStore } from '@/stores/local/createContextLocalStore';

import { OrganizationSectionsStore } from './OrganizationSectionsStore';

export * from './OrganizationSectionsStore';

export const { Provider: OrganizationSectionsStoreProvider, useStore: useOrganizationSectionsStore } =
  createContextLocalStore(OrganizationSectionsStore);
